import { createFileRoute } from '@tanstack/react-router'
import {
  ADMIN_ANNOUNCEMENT_FILTER_KEYS,
  ADMIN_ANNOUNCEMENT_SORT_IDS,
} from '@/features/announcements/components/announcements/admin-announcements-columns'
import { AdminAnnouncementsPage } from '@/features/announcements/pages/admin-announcements-page'
import { createTableSearchSchema } from '@/lib/data-table/search-schema'

const announcementsSearchSchema = createTableSearchSchema({
  defaultPageSize: 20,
  sortIds: ADMIN_ANNOUNCEMENT_SORT_IDS,
  filterKeys: ADMIN_ANNOUNCEMENT_FILTER_KEYS,
})

export const Route = createFileRoute('/announcements')({
  staticData: { title: 'Banners' },
  validateSearch: announcementsSearchSchema,
  component: AdminAnnouncementsPage,
})
